import _ from "lodash";
import Vue from "vue";
import Component from "vue-class-component";

@Component
class ViewportAware extends Vue {
	constructor() {
		super();

		this.viewportData = {};

		this.viewportData.scrollOffsets = {
			x: 0,
			y: 0
		};

		this.viewportData.viewportSize = {
			w: 0,
			h: 0
		};
	}

	mounted() {
		this.onScroll();
		this.onResize();

		this.debouncedOnScroll = _.debounce(this.onScroll, 1000, true);

		window.addEventListener("scroll", this.debouncedOnScroll);
		window.addEventListener("resize", this.onResize);
	}

	beforeDestroy() {
		window.removeEventListener("scroll", this.debouncedOnScroll);
		window.removeEventListener("resize", this.onResize);
	}

	onScroll() {
		// Update scrollOffsets
		this.viewportData.scrollOffsets.x = window.pageXOffset;
		this.viewportData.scrollOffsets.y = window.pageYOffset;
	}

	onResize() {
		// console.debug("ViewportAware.onResize():", this);
		// Update viewportSize
		this.viewportData.viewportSize.w = window.innerWidth;
		this.viewportData.viewportSize.h = window.innerHeight;
	}
}

export default ViewportAware;
